import React, { useState } from "react";
import ServiceRequestModal from "./ServiceRequestModal";
import QuoteRequestModal from "./QuoteRequestModal";
import EngineeringIcon from "./EngineeringIcons";

const Hero: React.FC = () => {
  const [isServiceModalOpen, setIsServiceModalOpen] = useState(false);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <section className="relative bg-gray-900 text-white">
      {/* Background Videos */}
      <div className="absolute inset-0">
        <div className="relative w-full h-full">
          {/* First Video */}
          <video
            src="https://kasoa-market-s3.s3.us-east-1.amazonaws.com/video1.mp4"
            autoPlay
            muted
            loop
            className="absolute inset-0 w-full h-full object-cover opacity-90 animate-fade-in-out"
            style={{
              animation: "fadeInOut 10s infinite",
            }}
          />
          {/* Second Video */}
          <video
            src="https://kasoa-market-s3.s3.us-east-1.amazonaws.com/video2.mp4"
            autoPlay
            muted
            loop
            className="absolute inset-0 w-full h-full object-cover opacity-60 animate-fade-in-out"
            style={{
              animation: "fadeInOut 10s infinite 5s",
            }}
          />
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-4 py-24 lg:py-32">
        <div className="max-w-4xl relative z-10 p-8 rounded-lg bg-black/50">
          {/* Animated Engineering Icons */}
          <div className="absolute -top-4 -left-4 animate-spin-slow">
            <EngineeringIcon type="gear" size="lg" className="text-orange-500/30" />
          </div>
          <div className="absolute -top-4 -right-4 animate-spin-slow-reverse">
            <EngineeringIcon type="cog" size="md" className="text-orange-400/30" />
          </div>
          <div className="absolute -bottom-4 -left-4 animate-spin-slow">
            <EngineeringIcon type="pulley" size="md" className="text-orange-300/30" />
          </div>
          <div className="absolute -bottom-4 -right-4 animate-spin-slow-reverse">
            <EngineeringIcon type="gear" size="sm" className="text-orange-500/30" />
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ekumfi Engineering
          </h1>
          <p className="text-xl md:text-2xl text-orange-400 mb-4 font-semibold">
            Industrializing Ekumfiman Through Engineering Excellence
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl">
            A comprehensive engineering conglomerate driving sustainable development through 9 specialized engineering keystones. 
            From research & development to sustainable building solutions, we're building the future of Ekumfiman.
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl">
            <strong>Vision:</strong> Creating a unique self-sustainable environment to spearhead population-driven development.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <button
              onClick={() => setIsServiceModalOpen(true)}
              className="bg-orange-500 text-white px-8 py-3 rounded hover:bg-orange-600 transition-colors flex items-center gap-2 group"
            >
              <EngineeringIcon type="wrench" size="sm" className="group-hover:animate-tool-swing" animated={false} />
              Explore Our Services
            </button>
            <button
              onClick={() => setIsQuoteModalOpen(true)}
              className="border-2 border-white text-white px-8 py-3 rounded hover:bg-white hover:text-gray-900 transition-colors flex items-center gap-2"
            >
              <EngineeringIcon type="bolt" size="sm" animated={false} />
              Request Consultation
            </button>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="relative bg-black bg-opacity-75 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-orange-500 mb-2">9</div>
              <div className="text-gray-400">Engineering Keystones</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-orange-500 mb-2">50+</div>
              <div className="text-gray-400">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-orange-500 mb-2">100%</div>
              <div className="text-gray-400">Sustainable Focus</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-orange-500 mb-2">∞</div>
              <div className="text-gray-400">Innovation Potential</div>
            </div>
          </div>
        </div>
      </div>

      <ServiceRequestModal
        isOpen={isServiceModalOpen}
        onClose={() => setIsServiceModalOpen(false)}
      />

      <QuoteRequestModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
      />
    </section>
  );
};

export default Hero;
